import { useState, useEffect, useContext } from "react";
import * as Location from "expo-location";
import { MAP_REGION_INITIAL } from "../services/Config";
import { GlobalContext } from "../contexts/global";

const timeout = 5000;

const useLocation = () => {
  const [location, setLocation] = useState(MAP_REGION_INITIAL);
  const { setLoading } = useContext(GlobalContext);

  // useEffect(
  //   () =>
  //     setLoading({
  //       show: true,
  //       message: "Pegando sua localização",
  //     }),
  //   []
  // );

  function getCurrentLocation() {
    return new Promise(async (resolve, reject) => {
      setTimeout(() => { reject(new Error(`Error getting gps location after ${(timeout * 2) / 1000} s`)) }, timeout * 2);
      setTimeout(async () => { resolve(await Location.getLastKnownPositionAsync()) }, timeout);
      resolve(await Location.getCurrentPositionAsync({accuracy: Location.Accuracy.Highest, maximumAge: 10000}));
    });
  }

  useEffect(() => {
    let isMounted = true;

    const getLocation = async () => {
      try {
        let { status } = await Location.requestForegroundPermissionsAsync();
        if (status !== "granted") {
          return;
        }

        const location = await getCurrentLocation();
        
        if (isMounted) {
          setLocation({
            latitude: location.coords.latitude,
            longitude: location.coords.longitude,
          });
        }
      } catch (err) {
        console.error("Error getting location:", err);
      } finally {
        setLoading({
          show: false,
          message: "",
        });
      }
    };

    getLocation();

    return () => {
      isMounted = false;
    };
  }, []);

  return location;
};

export default useLocation;
